module.exports = __webpack_public_path__ + "img/148.c989a8fd.jpg";